import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { LogIn } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vindo!");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex bg-[color:var(--marupiara-obsidian)]">
      <div className="hidden lg:block flex-1 relative">
        <img src={settings.admin_login_image || "https://images.unsplash.com/photo-1761437855598-011cf89b2ad4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(10,10,10,0.85), rgba(154,123,62,0.4))" }} />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <img src={settings.logo_url || "https://customer-assets.emergentagent.com/job_marupiara-editoracao/artifacts/nif8f45j_IMG-20260710-WA0205.jpg"} alt="Marupiara" className="w-20 h-20 rounded-full" style={{ background: "#0A0A0A" }} />
          <div>
            <div className="overline text-[color:var(--marupiara-gold)] mb-3">Painel Administrativo</div>
            <h1 className="font-serif text-5xl leading-tight max-w-md">Onde a gestão editorial ganha vida.</h1>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="w-full max-w-sm bg-[color:var(--marupiara-charcoal)] border border-[color:var(--marupiara-gold)]/30 p-8">
          <div className="lg:hidden mb-6 flex justify-center">
            <img src={settings.logo_url || "https://customer-assets.emergentagent.com/job_marupiara-editoracao/artifacts/nif8f45j_IMG-20260710-WA0205.jpg"} alt="Marupiara" className="w-16 h-16 rounded-full" style={{ background: "#0A0A0A" }} />
          </div>
          <h2 className="font-serif text-3xl text-[color:var(--marupiara-gold)] mb-1">Login</h2>
          <p className="text-white/60 text-sm mb-8">Acesse o painel da Marupiara</p>
          <div className="space-y-4">
            <div>
              <label className="overline text-[10px] text-white/60">E-mail</label>
              <input required type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-black/40 border border-white/10 text-white px-3 py-2.5 focus:border-[color:var(--marupiara-gold)] focus:outline-none" />
            </div>
            <div>
              <label className="overline text-[10px] text-white/60">Senha</label>
              <input required type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-black/40 border border-white/10 text-white px-3 py-2.5 focus:border-[color:var(--marupiara-gold)] focus:outline-none" />
            </div>
            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold w-full justify-center">
              <LogIn size={16} /> {loading ? "Entrando…" : "Entrar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
